// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../node_modules/css-loader/index.js!../../../node_modules/sass-loader/lib/loader.js!./_toolbox_fonts.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../node_modules/vue-style-loader/lib/addStylesClient.js")("51e168fa", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./src/assets/scss/_toolbox_fonts.scss
// module id = 8
// module chunks = 0